import React from "react";
import { Typography } from "@mui/material";
import { Stack } from "components/layout/reusableLayouts";

interface StepHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
}

const StepHeader: React.FC<StepHeaderProps> = ({
  title,
  subtitle,
  children,
}) => (
  <Stack gap="var(--space-3)">
    <Typography variant="h5" component="h1">
      {title}
    </Typography>
    {subtitle && (
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        {subtitle}
      </Typography>
    )}
    {children}
  </Stack>
);

export default StepHeader;
